<template>
  <div class="step_three">
    <div class="text-subtitle font-weight-medium mb-4 mr-auto">
      Длительность проекта:
    </div>


    <v-container>
      <v-radio-group v-model="value">
        <div class="r-group">
          <div v-for="item in duration" :key="item.id">
            <div class="radio_lvl_3">
              <v-radio              
                :label="item.label"
                :value="item.id"
                color= "#388e3c"
                on-icon="mdi-checkbox-marked-circle-outline"
                @click="setDurationValue(item.id)"
              >
              <template v-slot:label>
                  <div class="ml-3">
                     <strong class="blue-grey--text text--darken-4">{{item.label}}</strong>
                  </div>
                </template>
              
              </v-radio>
            </div>
          </div>
        </div>
      </v-radio-group>
    </v-container>
    <v-btn
      :disabled = "getDurationValue === ''"
      :class="'ml-auto mt-6'"
      color="success"
      elevation="2"
      large
      width="100px"
      @click="changeStep('four')"
    >
      Далее
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  data() {
    return {
      value: "",
      duration: [
        {
          id: 1,
          label: "менее 3-х месяцев",
        },
        {
          id: 2,
          label: "3-6 месяцев",
        },
        {
          id: 3,
          label: "6-12 месяцев",
        },
        {
          id: 4,
          label: "более года",
        },
      ],
    };
  },
  methods: {
      ...mapActions(['changeStep','setDurationValue'])
  },
  computed: {
      ...mapGetters(['getDurationValue'])
  }
};
</script>

<style lang="sass" scoped>
.step_three
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    flex-wrap: wrap
.radio_lvl_3
    cursor: pointer
    max-width: 307px
    padding-left: 20px
    height: 100px
    margin: 10px
    border: 2px solid #43A047
    border-radius: 10px
    display: flex
    align-items: center
    justify-content: space-between
    position: relative
    font-style: normal
    font-weight: 500
    font-size: 22px
    line-height: 16px
    font-feature-settings: 'liga' off
    color: #388e3c

@media (min-width: 745px)
  .r-group
      display: grid
      grid-template-columns: 327px 327px
      margin: 0 auto
</style>